import React from 'react';

import "./styles.scss";

const HomePage = () => {
  return (
    <div>Extension HomePage</div>
  )
}

export default HomePage;